// @ts-nocheck
/* eslint-disable */
import CheckPermission from 'components/CheckPermission';
import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  memo,
  useMemo,
} from 'react';
import Select, { components } from 'react-select';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ErrorOutline } from '@material-ui/icons';
import { error } from 'assets/colors/colors';
const CustomTooltip = withStyles({
  tooltip: {
    maxWidth: 350,
  },
})(Tooltip);
const noop = () => {};
const SingleValue = (props) => (
  <components.SingleValue {...props}>
    {props.selectProps.getOptionDisplay
      ? props.selectProps.getOptionDisplay(props.data)
      : props.selectProps.getOptionLabel
        ? props.selectProps.getOptionLabel(props.data)
        : props.data.label}
  </components.SingleValue>
);

const SelectComponent = (props) => {
  const {
    //required if options are grouped //must be false for showNumberss
    isGrouped = false,
    // required for multiple select options
    isMulti,
    // what to show when no options is available
    noOptionsMessage,

    // custom message if no searchable
    noOptionCustomMessage,
    //required for checkbox
    withCheckBox,
    //required function for async operations // isSearchable must be true for async handler
    asyncHandler,
    menuPlacement = 'auto',
    value,
    options,
    // to hide select all options
    hideSelectAll,
    //to show how many inputs are selected
    showNumbers = false,
    customOption,
    customClockInCheck,
    customToolTipInfo,
    // user can type search data
    isSearchable = true,
    // user can clear the selected option
    isClearable = true,
    isForceClearable,
    isCustomControl,
    //name of select
    name,
    placeholder,
    //function to capture selected in parent
    onChange,
    onBlur,
    //to show or hide selected options // may alter on checkbox
    hideSelectedOptions,
    // string or function
    optionLabel,
    optionValue,
    optionDisplay,
    disabled,
    loading,
    innerRef,
    defaultValue,
    creatable,
    creatableLabel,
    creatableOnClick = noop,
    createPermission,
    clearSelectedNumbers = false,
    //just to test if there is query on async select //make sure no query is empty if you want to show numbers
    query,
    filterOption,
    persistInput,
    backspaceRemovesValue,
    closeMenuOnSelect,
    onParentChange,
    menuPortalTarget,
    hardMenuOpen,
    wrapperClassName,
    autoFocus,
    trim = false,
    isValueFilter,
    labelTextValue,
    labelTextKey,
    newLabelValue,
    skipMemorizedValue,
    defaultMenuIsOpen = false,
    isHideDropdownIndicator = false,
    consoleData = false,
    closeMenuOnChange,
    isProjectSelected = false,
    MenuComponent,
    hasError,
    ...rest
  } = props;
  let timeOutRef = useRef();

  const [selected, setSelected] = useState(isMulti ? [] : null);
  const [searchInput, setSearchInput] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    setSelected(value);
  }, [value]);
  const dot = (data) => {
    if (data?.is_new || newLabelValue) {
      return {
        alignItems: 'center',
        display: 'flex',

        ':before': {
          backgroundColor: 'orange',
          borderRadius: 10,
          content: '"New"',
          display: 'block',
          marginRight: 10,
          padding: '3px 6px 3px 6px',
          fontSize: 10,
          color: '#fff',
        },
      };
    }
  };

  const colourStyles = {
    menu: (styles) => ({
      ...styles,
      zIndex: 9,
      // minHeight: '1rem',
      // maxHeight: '200px',
    }),
    menuList: (styles) => ({
      ...styles,
      // minHeight: '1rem',
      // maxHeight: '200px',
    }),
    option: (styles, { isDisabled, isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isDisabled
        ? '#F5F5F5'
        : isSelected && withCheckBox
          ? '#fff !important'
          : isSelected
            ? '#fbad33'
            : isFocused
              ? '#e6e9ee'
              : '#fff',
      color: '#000',
      wordBreak: 'break-word',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      borderBottom: '1px solid #e5e5e5',
      ':focus': {
        backgroundColor: '#fff',
      },
      ':active': {
        backgroundColor: '#fff',
      },
    }),
    control: (styles) => ({
      ...styles,
      ':div:div': { fontSize: 14 },
      backgroundColor: '#fff',
      border: hasError
        ? `1px solid ${error.main} !important`
        : '1px solid #dcdcdc',
      cursor: 'pointer',

      ':active': {
        ...styles[':active'],
        borderColor: '#f27921',
        border: '1px solid #f27921',
        boxShadow: 'none',
      },
      ':focus': {
        ...styles[':focus'],
        borderColor: '#f27921',
        border: '1px solid #f27921',
        boxShadow: 'none',
      },
      ':hover': {
        ...styles[':hover'],
        border: '1px solid #dcdcdc',
        boxShadow: 'none',
      },
      ':focus-within': {
        ...styles[':focus-within'],
        borderColor: '#f27921',
        border: '1px solid #f27921',
        boxShadow: 'none',
      },
    }),
    dropdownIndicator: (styles) => {
      return {
        ...styles,
        padding: 0,
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        display: showNumbers ? 'none' : '-webkit-box',
        borderRadius: '50px',
        padding: '0px 0px 0px 5px',
      };
    },
    multiValueRemove: (styles) => ({
      ...styles,
      ':hover': {
        ...styles[':hover'],
        borderRadius: '0px 50px 50px 0px',
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 99999 }),
    input: (styles, { data }) => ({ ...styles, ...dot(data) }),
    // placeholder: (styles) => ({ ...styles, fontSize: 12, color: '#98a5b9' }),
    singleValue: (styles, { data }) => ({ ...styles, ...dot(data) }),
  };

  const getOptionLabel =
    typeof optionLabel === 'string' ? (o) => o[optionLabel] : optionLabel;

  const getOptionValue =
    typeof optionValue === 'string'
      ? (option) => {
          return option[optionValue];
        }
      : optionValue;

  const getOptionDisplay =
    typeof optionDisplay === 'string' ? (o) => o[optionDisplay] : optionDisplay;

  const handleChange = (e) => {
    let data = [];
    //if selected Select all

    const found =
      Array.isArray(e) &&
      e.some((item) => item[optionValue || 'value'] === 'SELECT_ALL');
    if (found) {
      if (options.length + 1 === e.length) {
        data = [];
        setSelected([]);
      } else {
        data = options;
        setSelected(options);
      }
    } else {
      data = e;
      setSelected(e);
    }
    //onChange from props
    if (onChange) {
      onChange(data);
    }
    if (onParentChange) {
      onParentChange();
    }
    // selectRef.current?.blur();
  };

  const handleInputChange = (input, action) => {
    //for async operation to get options as typed, call api in parent component
    setSearchInput(input);
    if (asyncHandler && isSearchable) {
      clearTimeout(timeOutRef.current);
      timeOutRef.current = setTimeout(() => {
        asyncHandler(input);
      }, 500);
    }
  };

  const getChecked = ({ ...propsData }) => {
    if (propsData.data[optionValue || 'value'] == 'SELECT_ALL') {
      if (selected?.length == options?.length) return true;
      else return false;
    } else if (
      propsData[optionValue || 'value'] !== 'SELECT_ALL' &&
      propsData.isSelected
    ) {
      return true;
    } else return false;
  };
  const Option = (propsData) => {
    return (
      <components.Option {...propsData}>
        <span className="vr-checkbox">
          {withCheckBox && (
            <input
              disabled={propsData?.isDisabled}
              type="checkbox"
              className="select-checkbox-selected"
              style={{ marginRight: 4 }}
              checked={getChecked({ ...propsData })}
              onChange={() => null}
            />
          )}
          <label
            style={{
              fontSize: 12,
              cursor: 'pointer',
              width: '100%',
            }}
          >
            {getOptionLabel
              ? trim
                ? getOptionLabel(propsData.data)?.length > 30
                  ? getOptionLabel(propsData.data).slice(0, 30) + '...'
                  : getOptionLabel(propsData.data)
                : getOptionLabel(propsData.data)
              : trim
                ? propsData?.data?.label?.length > 30
                  ? propsData?.data?.label?.slice(0, 30) + '...'
                  : propsData?.data?.label
                : propsData?.data?.label}
          </label>
        </span>
        {customClockInCheck && propsData.data.customClockInCheck !== false && (
          <CustomTooltip
            arrow
            placement="top"
            title={`This employee has ongoing shift from ${propsData.data.customClockInCheck}`}
          >
            <div
              style={{
                backgroundColor: '#4CAF504D',
                width: 150,
                height: 20,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px 8px',
                gap: '8px',
                right: 0,
                borderRadius: '28px',
                marginRight: 16,
              }}
            >
              <span
                style={{
                  width: '100%',
                  height: '10px',
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '10px',
                  lineHeight: '10px',
                  color: ' #4CAF50',
                  whiteSpace: 'nowrap',
                }}
              >
                Ongoing shift from {propsData.data.customClockInCheck}
              </span>
            </div>
          </CustomTooltip>
        )}
        {customOption && propsData.data.customOption && (
          <span
            className="text-white font-12"
            style={{
              backgroundColor: '#FBAD33',
              width: 40,
              height: 20,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 50,
              marginRight: 8,
            }}
          >
            {propsData.data.customOption}
          </span>
        )}
        {customToolTipInfo &&
          propsData.data.type === 'U' &&
          propsData.data.amount &&
          propsData.data.isDisabled === true && (
            <Tooltip
              arrow
              placement="top"
              title={`Limit exceeded! User can ${propsData.data.role} max: ${propsData.data.amount}`}
            >
              <ErrorOutline
                style={{ height: '18px', width: '18px', color: 'red' }}
              />
            </Tooltip>
          )}
      </components.Option>
    );
  };

  const selectRef = useRef();

  useImperativeHandle(innerRef, () => ({
    focus: () => selectRef?.current?.select?.inputRef?.focus(),
    selectRef,
    setSelected,
    setMenuOpen,
  }));

  const onTextClick = () => {
    selectRef.current.focus();
  };

  const Menu =
    MenuComponent ||
    ((props) => {
      return (
        <components.Menu {...props}>
          {props.children}
          {creatable && (
            <CheckPermission permission={createPermission}>
              <div
                className="select-footer"
                onClick={() => {
                  setMenuOpen(false);
                  creatableOnClick();
                }}
              >
                {creatableLabel || 'Create'}
              </div>
            </CheckPermission>
          )}
        </components.Menu>
      );
    });
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {props?.selectProps?.menuIsOpen ? (
          <ArrowDropUpIcon />
        ) : (
          <ArrowDropDownIcon />
        )}
      </components.DropdownIndicator>
    );
  };
  const memorizedValue = useMemo(() => {
    if (optionValue && !skipMemorizedValue)
      return (
        options?.find((o) => o[optionValue] === value?.[optionValue]) || value
      );
    return value;
  }, [value, options]);
  const getComponents = useMemo(() => {
    let components = {
      Option,
      SingleValue,
      DropdownIndicator: isHideDropdownIndicator
        ? () => null
        : DropdownIndicator,
      IndicatorSeparator: () => null,
    };
    if (creatable) {
      components = {
        ...components,
        Menu,
      };
    }
    return components;
  }, [Option, SingleValue, DropdownIndicator, Menu]);

  const isProjectSelectedNameHandler = () => {
    if (isProjectSelected) {
      if (selected.length > '1') {
        return 'projects';
      }
      return 'project';
    }
    return null;
  };

  return (
    <>
      <div
        className={
          wrapperClassName
            ? `select-component-wrapper ${wrapperClassName}`
            : 'select-component-wrapper'
        }
      >
        <Select
          defaultMenuIsOpen={defaultMenuIsOpen}
          autoFocus={autoFocus}
          menuPlacement={menuPlacement}
          ref={selectRef}
          value={isMulti ? selected : memorizedValue}
          isDisabled={disabled}
          menuIsOpen={hardMenuOpen ? hardMenuOpen : menuOpen}
          isLoading={loading}
          onBlur={onBlur}
          isSearchable={isSearchable}
          onMenuOpen={() => setMenuOpen(true)}
          onMenuClose={() => setMenuOpen(false)}
          isClearable={
            isForceClearable ||
            (!showNumbers && isClearable) ||
            (showNumbers && isClearable)
          }
          isMulti={isMulti ? true : false}
          components={getComponents}
          name={name || ''}
          hideSelectedOptions={hideSelectedOptions}
          disableSelectedOptions={true}
          closeMenuOnSelect={
            typeof closeMenuOnSelect === 'boolean'
              ? closeMenuOnSelect
              : !isMulti
          }
          inputValue={persistInput ? searchInput : undefined}
          options={
            isSearchable && (loading || (persistInput ? !searchInput : false))
              ? []
              : !isGrouped && isMulti && options?.length && !hideSelectAll
                ? [
                    {
                      [optionLabel || 'label']: 'Select All',
                      [optionValue || 'value']: 'SELECT_ALL',
                    },
                    ...options,
                  ]
                : options
          }
          onChange={(e) => handleChange(e)}
          onInputChange={handleInputChange}
          placeholder={placeholder}
          noOptionsMessage={
            isSearchable && !query?.search_key
              ? () => noOptionsMessage || noOptionCustomMessage
              : () => 'No options'
          }
          // className={isMulti ? 'basic-multi-select' : 'basic-single'}
          classNamePrefix="select"
          styles={colourStyles}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          getOptionDisplay={getOptionDisplay}
          openMenuOnFocus
          filterOption={filterOption}
          backspaceRemovesValue={backspaceRemovesValue}
          menuPortalTarget={menuPortalTarget}
          {...rest}
        />
        {clearSelectedNumbers
          ? undefined
          : isMulti &&
            showNumbers &&
            !isGrouped &&
            !searchInput?.length &&
            // !isSearchable &&
            selected?.length > 0 && (
              <div className="number-of-selected" onClick={() => onTextClick()}>
                {selected.length} {isProjectSelectedNameHandler()} selected
              </div>
            )}
      </div>
    </>
  );
};

export default memo(SelectComponent);
